<ul
  *ngIf="version !== 3"
  #menuRef
  class="cmx-navbar__menu"
  [ngClass]="{
    'cmx-navbar__menu--mobile': isMobile,
    'cmx-navbar__menu--hidden': !isMobile && isLegalEntityListOpen
  }"
>
  <li
    class="position-relative"
    [ngClass]="{ flex: isCollapsed && menuItemSelectedId !== -1 }"
    *ngFor="let menuItem of menu.menuItems | async"
    [attr.data-tid]="'menu-item-' + menuItem.menu.menuId"
  >
    <div
      class="cmx-navbar__menu-item"
      [ngClass]="{
        'cmx-navbar__menu-item--selected': menuItemSelectedId === menuItem.menu.menuId,
        'cmx-navbar__menu-item--collapsed': isCollapsed && !isMobile,
        'cmx-navbar__menu-item--rtl': isRtl,
        'cmx-navbar__menu-item--rtl-selected': isRtl && menuItemSelectedId === menuItem.menu.menuId
      }"
      (click)="menuItemClick(menuItem.menu)"
    >
      <div
        class="cmx-navbar__menu-icon"
        [ngClass]="{ 'cmx-navbar__menu-icon--selected': menuItemSelectedId === menuItem.menu.menuId }"
      >
        <span [ngClass]="menuItem.applicationIcon"></span>
      </div>
      <div
        class="cmx-navbar__menu-label"
        [ngClass]="{
          'cmx-navbar__menu-label--mobile': isMobile,
          'cmx-navbar__menu-label--collapsed': isCollapsed && !isMobile,
          'cmx-navbar__menu-label--selected': menuItemSelectedId === menuItem.menu.menuId
        }"
      >
        {{ menuItem.menu.menuTitle | ellipsis }}
      </div>
    </div>
    <ul
      *ngIf="menuItemSelectedId === menuItem.menu.menuId && !isCollapsed"
      [@dropdown]=""
      class="cmx-navbar__menu-sub"
      [ngClass]="{
        'cmx-navbar__menu-sub--mobile': isMobile,
        'cmx-navbar__menu-sub--rtl': isRtl
      }"
    >
      <li
        *ngFor="let subItem of menuItem.menu.menuItems"
        (click)="subItemClick(subItem)"
        class="cmx-navbar__menu-sub-item"
        [attr.data-tid]="'submenu-item-' + subItem.menuId"
      >
        {{ subItem.menuTitle | ellipsis }}
      </li>
    </ul>
    <ul
      *ngIf="menuItemSelectedId === menuItem.menu.menuId && isCollapsed && !isMobile"
      [@slideout]=""
      class="cmx-navbar__menu-sub"
      [ngClass]="{
        'cmx-navbar__menu-sub--rtl': isRtl,
        'cmx-navbar__menu-sub--collapsed': isCollapsed
      }"
    >
      <li
        *ngFor="let subItem of menuItem.menu.menuItems"
        (click)="subItemClick(subItem)"
        class="cmx-navbar__menu-sub-item"
        [ngClass]="{ 'cmx-navbar__menu-sub-item--collapsed': isCollapsed }"
      >
        {{ subItem.menuTitle | ellipsis }}
      </li>
    </ul>
  </li>
</ul>
<!-- Sidenav Menu v3 -->
<ng-container *ngIf="version === 3">
  <cwc-sidenav-menu-item
    *ngFor="let menuItem of menu.menuItems | async; let i = index"
    [id]="'cmx-sidebar-app-' + menuItem.applicationTitle"
    [label]="menuItem.menu.menuTitle"
    [iconName]="menuItem.applicationIcon.replace('cmx-icon-', '')"
    [active]="menuItem.menu.menuId == this.menuItemIdActive"
    [attr.data-tid]="'menu-item-' + menuItem.menu.menuId"
    (cwcClick)="menuItemClick(menuItem.menu)"
    [variant]="variant"
  >
    <cwc-sidenav-menu-item
      *ngFor="let subItem of menuItem.menu.menuItems; let j = index"
      [label]="subItem.menuTitle"
      [active]="subItem.menuId == this.subMenuItemIdActive"
      data-id="cmx-sidebar-app-subitem-{{ subItem.menuTitle }}"
      (cwcClick)="subItemClick(subItem)"
      [variant]="variant"
    ></cwc-sidenav-menu-item>
  </cwc-sidenav-menu-item>
</ng-container>
